import { FadeUp, Eyebrow } from "./motion";

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-36 border-t border-[#27272a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <FadeUp>
              <Eyebrow num="04">About ErgoAssist</Eyebrow>
            </FadeUp>
            <FadeUp delay={0.05}>
              <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight text-[#f5f5f5] mt-6 leading-[1.05]">
                Engineers, ergonomists, and people who care about workers.
              </h2>
            </FadeUp>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <FadeUp delay={0.1}>
              <p className="text-lg leading-relaxed text-[#a1a1aa]">
                ErgoAssist was founded on a simple observation: the tools that move the modern
                economy still rely on human backs, shoulders and knees — and those wear out.
                We set out to build wearable technology that makes physical work sustainable.
              </p>
              <p className="text-lg leading-relaxed text-[#a1a1aa] mt-6">
                Our soft-shell exoskeleton pairs a breathable textile harness with a precision
                spring-hydraulic core. The result is assistance that feels invisible until the
                moment you need it — no batteries, no cables, no learning curve.
              </p>
            </FadeUp>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-[#27272a] border border-[#27272a] mt-12">
              {[
                ["2021", "Founded"],
                ["3", "Patents pending"],
                ["12+", "Pilot deployments"],
                ["4", "Industry sectors"],
                ["100%", "Passive assist"],
                ["India", "Designed & built"],
              ].map(([n, l], i) => (
                <div key={i} data-testid={`about-stat-${i}`} className="bg-[#121212] p-6">
                  <div className="font-display text-3xl text-[#ff4500]">{n}</div>
                  <div className="font-mono-accent text-[11px] uppercase tracking-wider text-[#a1a1aa] mt-1">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
